/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

import store from './store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [{
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Panel Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Resumen',
                active: true
              },
            ],
            pageTitle: 'Inicio',
          }
        },

        // =============================================================================
        // Meli Flex — mismas vistas que ME1, parametrizadas por `mode`
        // =============================================================================
        {
          path: '/meli-flex/configuracion',
          name: 'flex-configuracion',
          component: () => import('./views/MeliFlex/Settings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/admin/home' },
              { title: 'Envíos Flex', active: true },
              { title: 'Configuración', active: true }
            ],
            pageTitle: 'Configuración Envíos Flex',
          }
        },
        {
          path: '/meli-flex/ordenes/por-enviar',
          name: 'flex-ordenes-por-enviar',
          props: { mode: 'flex' },
          component: () => import('./views/Orders/OrdersPending.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/admin/home' },
              { title: 'Envíos Flex', active: true },
              { title: 'Por Enviar', active: true }
            ],
            pageTitle: 'Órdenes Flex',
          }
        },
        {
          path: '/meli-flex/ordenes/procesadas',
          name: 'flex-ordenes-procesadas',
          props: { mode: 'flex' },
          component: () => import('./views/Orders/OrdersProcessing.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/admin/home' },
              { title: 'Envíos Flex', active: true },
              { title: 'Procesadas', active: true }
            ],
            pageTitle: 'Órdenes Flex',
          }
        },
        {
          path: '/meli-flex/ordenes/invalidas',
          name: 'flex-ordenes-invalidas',
          props: { mode: 'flex' },
          component: () => import('./views/Orders/OrdersInvalid.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/admin/home' },
              { title: 'Envíos Flex', active: true },
              { title: 'Inválidas', active: true }
            ],
            pageTitle: 'Órdenes Flex',
          }
        },
        {
          path: '/meli-flex/ordenes/desestimadas',
          name: 'flex-ordenes-desestimadas',
          props: { mode: 'flex' },
          component: () => import('./views/Orders/OrdersArchived.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/admin/home' },
              { title: 'Envíos Flex', active: true },
              { title: 'Desestimadas', active: true }
            ],
            pageTitle: 'Órdenes Flex',
          }
        },
        {
          path: '/ordenes/por-enviar',
          name: 'ordenes-por-enviar',
          props: { mode: 'me1' },
          component: () => import('./views/Orders/OrdersPending.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Envíos M1',
                active: true
              },
              {
                title: 'Por Enviar',
                active: true
              }
            ],
            pageTitle: 'Órdenes M1',
          }
        },
        {
          path: '/ordenes/procesadas',
          name: 'ordenes-procesadas',
          props: { mode: 'me1' },
          component: () => import('./views/Orders/OrdersProcessing.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Envíos M1',
                active: true
              },
              {
                title: 'Procesadas',
                active: true
              }
            ],
            pageTitle: 'Órdenes Procesadas',
          }
        },

        {
          path: '/ordenes/invalidas',
          name: 'ordenes-invalidas',
          props: { mode: 'me1' },
          component: () => import('./views/Orders/OrdersInvalid.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Envíos M1',
                active: true
              },
              {
                title: 'Inválidas',
                active: true
              }
            ],
            pageTitle: 'Ordenes Inválidas',
          }
        },

        {
          path: '/ordenes/desestimadas',
          name: 'ordenes-desestimadas',
          props: { mode: 'me1' },
          component: () => import('./views/Orders/OrdersArchived.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Envíos M1',
                active: true
              },
              {
                title: 'Desestimadas',
                active: true
              }
            ],
            pageTitle: 'Órdenes Desestimadas',
          }
        },

        {
          path: '/flete-dinamico/publicaciones',
          name: 'flete-dinamico-publicaciones',
          component: () => import('./views/DynamicFreight/Publications.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Flete Dinamico',
                active: false
              },
              {
                title: 'Publicaciones',
                active: true
              }
            ],
            pageTitle: 'Publicaciones',
          }
        },
        {
          path: '/catalogo',
          name: 'catalogo',
          component: () => import('./views/Catalog/Index.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Catálogo',
                active: false
              },
              {
                title: 'Publicaciones',
                active: true
              }
            ],
            pageTitle: 'Catálogo',
          }
        },

        {
          path: '/flete-dinamico/configuracion',
          name: 'flete-dinamico-configuracion',
          component: () => import('./views/DynamicFreight/Configuration.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Flete Dinamico',
                active: false
              },
              {
                title: 'Configuracion',
                active: true
              }
            ],
            pageTitle: 'Configuracion',
          }
        },
        {
          path: '/flete-dinamico/sucursales-configuracion',
          name: 'flete-dinamico-sucursales-configuracion',
          component: () => import('./views/DynamicFreight/BranchesSettings.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Flete Dinamico',
                active: false
              },
              {
                title: 'Sucursales',
                url: '/flete-dinamico/sucursales',
                active: true,
              },
              {
                title: 'Configuración',
                active: true
              },
            ],
            pageTitle: 'Sucursales',
          }
        },
        {
          path: '/flete-dinamico/sucursales',
          name: 'flete-dinamico-sucursales',
          component: () => import('./views/DynamicFreight/Branches.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Flete Dinamico',
                active: false
              },
              {
                title: 'Sucursales',
                active: true
              }
            ],
            pageTitle: 'Sucursales',
          }
        },
        {
          path: '/conexiones',
          name: 'conexiones',
          component: () => import('./views/Conections.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Conexiones',
                active: true
              },
              {
                title: 'Detalle',
                active: true
              }
            ],
            pageTitle: 'Conexiónes',
          }
        },

        {
          path: '/cuenta',
          name: 'cuenta',
          component: () => import('./views/Account.vue'),
          meta: {
            breadcrumb: [{
                title: 'Inicio',
                url: '/admin/home'
              },
              {
                title: 'Cuenta',
                active: true
              },
              {
                title: 'Detalle',
                active: true
              }
            ],
            pageTitle: 'Cuenta',
          }
        },

      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [{
          path: '/guest',
          name: 'guest-page',
          component: () => import('@/views/pages/Guest.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        // Ruta especial para iniciar el login desde CDS 
        {
          path: '/cds-start-login',
          name: 'cds-start-login',
          component: () => import('./components/StartCDSLogin.vue')
        },
        {
          path: '/branches-verification',
          name: 'branches-verification',
          component: () => import('@/views/pages/BranchesVerifications.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    },

    // Ruta especial para iniciar el login desde CDS 
    /*{
      path: '/cds-start-login',
      name: 'cds-start-login',
      component: () => import('./components/StartCDSLogin.vue')
    }*/
  ],
})

const unguardedRoutesNames = ['guest-page', 'page-error-404', 'cds-start-login'];

router.beforeEach(async (to, from, next) => {
  // `indexOf(...) < 1` daba true tambien para el indice 0, o sea que 'guest-page'
  // —la primera de la lista— se trataba como ruta protegida: al caer ahi por sesion
  // vencida se pedia /api/user de nuevo y se redirigia a /guest estando ya en /guest.
  if (unguardedRoutesNames.indexOf(to.name) === -1) {
    if (!store.state.authUser.id) {
      // Con `await` la navegacion espera a tener el usuario. Sin esto el layout se
      // monta antes de que el store este poblado y termina pidiendo /api/user por
      // segunda vez (ver Main.vue).
      await store.dispatch('attemptLoadUser');
    }
    // Check Meli connection
    /*console.log('store.state.authUser.meli_id', store.state.authUser.meli_id);
    console.log(to, from);
    if(!store.state.authUser.meli_id && (
      to.name!='conexiones' 
      //&& from.name!='conexiones' 
      ) ){
      // No tiene meli conectado 
      console.log('No tiene meli conectado ');
      //next(false);
      next('/conexiones')
      if(from.name!='conexiones'){ router.push('/conexiones')}
    } */
  }

  // Rutas de Meli Flex: un merchant sin la habilitacion no debe poder entrar por URL.
  //
  // Aca SI hay que esperar la carga del usuario: el dispatch de arriba no se aguarda, asi
  // que en una entrada directa el store todavia esta vacio y evaluar el flag daria falso
  // negativo, echando a un merchant que si tiene Flex. El await se limita a estas rutas
  // para no cambiar el arranque del resto de la aplicacion.
  if (to.path.startsWith('/meli-flex')) {
    if (!store.state.authUser.id) {
      await store.dispatch('attemptLoadUser');
    }
    if (store.state.authUser.meli_flex_enabled !== true) {
      return next('/');
    }
  }

  next();

})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
